module.exports = __webpack_public_path__ + "static/img/img_logo.8d33b25b.png";